<template lang="pug">
vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-is-valid="!$v.detail.$invalid" :vm-active="isModalScopeVisible" :vm-title='getTitle')
  vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12" v-shortcuts="[{ shortcut: [ 'enter', ], callback: saveRecord, push: true, focus: true },]")
    vm-col.btn-categories-add(vm-justify="center", vm-align="center", vm-w=12)
      vm-button(icon="plus" @click="addCategories" ) {{ $t('strings.categories') }}
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-typeahead(url="categories" :label='$t("projects.category_id")' disable-match :serializer="item => item.type" :data="inOrdersCatalog.categories" :placeholder='$t("projects.category_id_placeholder")' :danger="$v.detail.category.$invalid && $v.detail.category.$model" :danger-text="$t('validation.required', { attribute: $t('projects.category') })" v-model="detail.category" :filter="query => `param=${query},type`" @input-change="autoCompleteFunc" :default-value="isAdd ? '' : detail.category.type")
          template(slot-scope="{data}")
            vm-typeahead-item(is="vm-typeahead-item" v-bind:key="index" v-bind:value="item.data" v-bind:text="item.text" v-for="item,index in data")
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-input(:placeholder='$t("projects.sequence_placeholder")' :danger="$v.detail.sequence.$invalid && $v.detail.sequence.$model" :danger-text="$t('validation.required', { attribute: $t('projects.sequence') })" v-model="detail.sequence" :label='$t("projects.sequence")' required type="number")
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-input(:placeholder='$t("projects.description_placeholder")' :danger="$v.detail.description.$invalid && $v.detail.description.$model" :danger-text="$t('validation.required', { attribute: $t('projects.description') })" v-model="detail.description" :label='$t("projects.description")')
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-input(:placeholder='$t("projects.quantity_placeholder")' :danger="$v.detail.quantity.$invalid && $v.detail.quantity.$model" :danger-text="$t('validation.required', { attribute: $t('projects.quantity') })" v-model="detail.quantity" :label='$t("projects.quantity")' required type="number")
    vm-col(vm-justify="center", vm-align="center", vm-w=12)
      b-form-group
        vm-input(:placeholder='$t("projects.mark_placeholder")' :danger="$v.detail.mark.$invalid && $v.detail.mark.$model" :danger-text="$t('validation.required', { attribute: $t('projects.mark') })" v-model="detail.mark" :label='$t("projects.mark")')
</template>
<script>
import { required } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('InOrders')

export default {
  name: 'ModalProjectDetail',
  props: {
    detail: {
      type: Object
    },
    index: {
      type: Number
    },
    project_id: {
      type: Number
    },
    isAdd: {
      default: true,
      type: Boolean
    }
  },
  validations: {
    detail: {
      category: {
        required
      },
      sequence: {
        required
      },
      description: {
        required
      },
      quantity: {
        required
      },
      mark: {
        required
      }

    }
  },
  computed: {
    ...mapGetters([
      'isModalScopeVisible',
      'inOrdersCatalog'
    ]),
    getTitle () {
      return this.isAdd ? 'Add details' : 'Edit details'
    }
  },
  methods: {
    ...mapActions([
      'addProjectDetail',
      'editProjectDetail',
      'setModalScopeVisible',
      'loadCatalog',
      'setModalCategoryVisible'
    ]),
    addCategories () {
      this.setModalCategoryVisible(true)
    },
    saveRecord () {
      this.isAdd ? this.addProjectDetail({ detail: this.detail, project_id: this.project_id }) : this.editProjectDetail({ detail: this.detail, index: this.index })
    },
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: `${value}&is_active=1`, url: url })
    },
    close () {
      this.setModalScopeVisible(false)
    }
  }
}
</script>

<style>
.vm-select--options {
  z-index: 400331 !important;
}
.btn-categories-add {
  display: flex;
  justify-content: flex-end !important;
}
</style>
